import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-s-leave",
  "use": "icon-s-leave-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 22 22\" id=\"icon-s-leave\"><path d=\"M22 0v22H6v-6h2v4h12V2H8v4H6V0zM4.243 6.757l1.414 1.415L3.828 10H16v2H3.828l1.829 1.828-1.414 1.415L0 11z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol